import { useMemo } from 'react';
import { CommentStore } from './FloatingCommentSidebar/store';
import { CommentStoreContext } from './contextStore';

export interface CommentStoreProviderProps {
	children: React.ReactNode;
}

export function CommentStoreProvider({ children }: CommentStoreProviderProps) {
	const commentStore = useMemo(() => new CommentStore(), []);
	return (
		<CommentStoreContext.Provider value={commentStore}>
			{children}
		</CommentStoreContext.Provider>
	);
}
